import { combineReducers } from 'redux';
import compose, * as fromCompose from './compose';
import fetch, * as fromFetch from './fetch';
import execute, * as fromExecute from './execute';
import selected, * as fromSelected from './selected';

export default combineReducers({
  execute,
  fetch,
  compose,
  selected,
});

export const getTemplates = (state) => fromFetch.getTemplates(state.fetch);

export const getDashboards = (state) => fromFetch.getDashboards(state.fetch);

export const getUpdateTime = (state) => fromCompose.getUpdateTime(state.compose);

export const getExtended = (state) => fromCompose.getExtended(state.compose);

export const getEditingDashboard = (state) => fromCompose.getEditingDashboard(state.compose);

export const getExecuteEditingDashboard = (state) =>
  fromCompose.getExecuteEditingDashboard(state.compose);

export const getDashboardName = (state) => fromCompose.getDashboardName(state.compose);

export const getEditingMode = (state) => fromCompose.getEditingMode(state.compose);

export const getCreatingMode = (state) => fromCompose.getCreatingMode(state.compose);

export const getUnits = (state) => fromCompose.getUnits(state.compose);

export const getIds = (state, unitId) => fromCompose.getIds(state.compose, unitId);

export const getGroupColumn = (state, unitId) => fromCompose.getGroupColumn(state.compose, unitId);

export const getSql = (state, unitId, id) => fromCompose.getSql(state.compose, unitId, id);

export const getError = (state, unitId, id) => fromCompose.getError(state.compose, unitId, id);

export const getName = (state, unitId, id) => fromCompose.getName(state.compose, unitId, id);

export const getUniqueChar = (state, unitId, id) =>
  fromCompose.getUniqueChar(state.compose, unitId, id);

export const getPeriodsState = (state, unitId, id) =>
  fromCompose.getPeriodsState(state.compose, unitId, id);

export const getFilter = (state, unitId, id) => fromCompose.getFilter(state.compose, unitId, id);

export const getAggregationColumn = (state, unitId, id) =>
  fromCompose.getAggregationColumn(state.compose, unitId, id);

export const getAggregationType = (state, unitId, id) =>
  fromCompose.getAggregationType(state.compose, unitId, id);

export const getSplitColumn = (state, unitId, id) =>
  fromCompose.getSplitColumn(state.compose, unitId, id);

export const getEvents = (state, unitId) => fromCompose.getEvents(state.compose, unitId);

export const getIdUsingTemplate = (state, unitId) =>
  fromCompose.getIdUsingTemplate(state.compose, unitId);

export const getEventsCsv = (state, unitId) => fromCompose.getEventsCsv(state.compose, unitId);

export const getOthersFilter = (state, unitId, id) =>
  fromCompose.getOthersFilter(state.compose, unitId, id);

export const getEventView = (state, unitId, id) =>
  fromCompose.getEventView(state.compose, unitId, id);

export const getEnteredFormula = (state, unitId) =>
  fromCompose.getEnteredFormula(state.compose, unitId);

export const getEnteredLegendName = (state, unitId) =>
  fromCompose.getEnteredLegendName(state.compose, unitId);

export const getIsFormulaOnly = (state, unitId) =>
  fromCompose.getIsFormulaOnly(state.compose, unitId);

export const getEventOptions = (state, unitId) =>
  fromCompose.getEventOptions(state.compose, unitId);

export const getDashboardRetentionSimpleFirstEvent = (state, unitId) =>
  fromCompose.getDashboardRetentionSimpleFirstEvent(state.compose, unitId);

export const getDashboardRetentionSimpleReturnEvent = (state, unitId) =>
  fromCompose.getDashboardRetentionSimpleReturnEvent(state.compose, unitId);

export const getDashboardRetentionSimpleDimensionType = (state, unitId) =>
  fromCompose.getDashboardRetentionSimpleDimensionType(state.compose, unitId);

export const getDashboardRetentionSimpleOptions = (state, unitId) =>
  fromCompose.getDashboardRetentionSimpleOptions(state.compose, unitId);

export const getFirstEvent = (state, unitId) => fromCompose.getFirstEvent(state.compose, unitId);

export const getFirstEventFilter = (state, unitId) =>
  fromCompose.getFirstEventFilter(state.compose, unitId);

export const getReturnEvent = (state, unitId) => fromCompose.getReturnEvent(state.compose, unitId);

export const getReturnEventFilter = (state, unitId) =>
  fromCompose.getReturnEventFilter(state.compose, unitId);

export const getUseLatestProfile = (state, unitId) =>
  fromCompose.getUseLatestProfile(state.compose, unitId);

export const getDimensionType = (state, unitId) =>
  fromCompose.getDimensionType(state.compose, unitId);

export const getFilterFor = (state, unitId, eventIndex) =>
  fromCompose.getFilterFor(state.compose, unitId, eventIndex);

export const isCustomSequenceEnabled = (state, unitId) =>
  fromCompose.isCustomSequenceEnabled(state.compose, unitId);

export const getCustomSequenceType = (state, unitId) =>
  fromCompose.getCustomSequenceType(state.compose, unitId);

export const getCustomSequence = (state, unitId) =>
  fromCompose.getCustomSequence(state.compose, unitId);

export const getCustomSequenceDimensions = (state, unitId) =>
  fromCompose.getCustomSequenceDimensions(state.compose, unitId);

export const getRetentionIdUsingTemplate = (state, unitId) =>
  fromCompose.getIdUsingTemplate(state.compose, unitId);

export const getRetentionComplexSQL = (state, unitId) =>
  fromCompose.getRetentionComplexSQL(state.compose, unitId);

export const getRetentionError = (state, unitId) => fromCompose.getError(state.compose, unitId);

export const getRetentionComplexOptions = (state, unitId) =>
  fromCompose.getRetentionComplexOptions(state.compose, unitId);

export const getEvent = (state, unitId) => fromCompose.getEvent(state.compose, unitId);

export const getColumns = (state, unitId) => fromCompose.getColumns(state.compose, unitId);

export const isAggregateEnabled = (state, unitId) =>
  fromCompose.isAggregateEnabled(state.compose, unitId);

export const getUserFilter = (state, unitId) => fromCompose.getUserFilter(state.compose, unitId);

export const getIdUsingUsersTemplate = (state, unitId) =>
  fromCompose.getIdUsingUsersTemplate(state.compose, unitId);

export const getUsersSQL = (state, unitId) => fromCompose.getUsersSQL(state.compose, unitId);

export const getUsersError = (state, unitId) => fromCompose.getUsersError(state.compose, unitId);

export const getAmountField = (state, unitId) => fromCompose.getAmountField(state.compose, unitId);

export const getAmountFields = (state, unitId) =>
  fromCompose.getAmountFields(state.compose, unitId);

export const getRevenueGroupColumn = (state, unitId) =>
  fromCompose.getRevenueGroupColumn(state.compose, unitId);

export const getRevenueSplitColumn = (state, unitId) =>
  fromCompose.getRevenueSplitColumn(state.compose, unitId);

export const getQueryType = (state, unitId) => fromCompose.getQueryType(state.compose, unitId);

export const getPaymentFilter = (state, unitId) =>
  fromCompose.getPaymentFilter(state.compose, unitId);

export const getOptions = (state, unitId) => fromCompose.getOptions(state.compose, unitId);

export const getQueries = (state) => fromExecute.getQueries(state.execute);

export const getTemplatesState = (state) => fromExecute.getTemplatesState(state.execute);

export const getUnitsExecutionState = (state) => fromExecute.getUnitsExecutionState(state.execute);

export const getSelectedDashboard = (state) => fromSelected.getSelected(state.selected);

export const getIsUpdatingDashboard = (state) => fromSelected.getIsUpdating(state.selected);

export const isUpdating = (state, unitId) => fromCompose.isUpdating(state.compose, unitId);

export const getUpdating = (state, unitId) => fromCompose.getUpdating(state.compose, unitId);

export const getUpdatingId = (state, unitId) => fromCompose.getUpdatingId(state.compose, unitId);

export const getFunnelConversionInterval = (state, unitId) =>
  fromCompose.getFunnelConversionInterval(state.compose, unitId);

export const getFunnelView = (state, unitId) => fromCompose.getFunnelView(state.compose, unitId);
